<template>
  <div class="agreement" :class="{ isiOSX: isiOSX }">
    <van-nav-bar :title="title" left-arrow :fixed="true" @click-left="closeContractSigned" class="agreement-title" />
    <div class="agreement-content">
      <p class="title">{{ title }}</p>
      <div id="content" v-html="content"></div>
    </div>

  </div>

</template>

<script>
  import navBar from "../components/navBar.vue";
  export default {
    components: {
      navBar
    },
    data() {
      return {
        isiOSX: false,
        isiOS: false,
        number: "",
        title: '',
        content: '',
      }
    },
    created() {
      let u = navigator.userAgent;
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      this.isiOSX = this.isIphoneX();
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      this.number = this.$route.query.number;
      this.getAgreement()
    },
    methods: {
      getAgreement() {
        this.$api.get('/cms-v2/index/agreement/app/detail', {
          number: this.number
        }).then(res => {
          this.title = res.title
          this.content = res.content
        })
      },
      closeContractSigned() {
        this.params('success', 'success', 'closeContractSigned');
      },
    },
  }
</script>

<style lang="less" scoped>
  body {
    min-height: 100%;
    height: auto;
    background: #f5f6f7;

    .van-nav-bar__title {
      font-size: 18px !important;
      font-weight: normal !important;
    }

    .agreement {
      height: 100%;

      &-title {
        height: 44px;
        line-height: 44px;
        padding-top: 24px;
        box-shadow: 0 1px 0 #eee;

        .van-nav-bar__title {
          color: #333;
          font-size: 17px;
          font-weight: 700;
        }
      }

      &-content {
        padding: 16px;
        padding-top: 68px;
        padding-bottom: 68px;
        box-sizing: border-box;
        height: 100%;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;

        .title {
          text-align: center !important;
          color: #333333;
          font-size: 18px;
          font-weight: bolder;
          margin: 24px 0;
        }
      }
    }

    .isiOSX {
      .agreement {
        &-title {
          padding-top: 44px;
        }

        &-reback {
          top: 45px;
        }

        &-content {
          padding-top: 88px;
        }
      }
    }

    .isPreview {
      .agreement {
        &-content {
          padding-top: 0px;
        }
      }
    }
  }

  /deep/.van-nav-bar .van-icon {
    color: #323233;
  }
</style>